import { lazy } from "react";
import { Navigate } from "react-router-dom";
const CareGapsV2Page = lazy(() => import("./pages/CareGapsV2Page"));
// Care Gaps V2 es la versión canónica en /care-gaps. /care-gaps-v2 y /CareGap
// redirigen ahí para no romper bookmarks de la beta ni links viejos.
export const careGapsV2Routes = [
  { path: "/care-gaps", element: <CareGapsV2Page /> },
  { path: "/care-gaps-v2", element: <Navigate to="/care-gaps" replace /> },
  { path: "/CareGap", element: <Navigate to="/care-gaps" replace /> },
];

export default CareGapsV2Page;
